import * as React from 'react';
import { Collapse } from 'react-collapse';

import { IAddress } from '../types';
import locationSearchApi from '../api/locationSearch';
import availabilityCheckApi from '../api/checkAvailability';
import { regexTest } from '../helpers';
import LocationSearch from './LocationSearch';
import RequestForm from './RequestForm';
import SuccessFeedback from './SuccessFeedback';

interface IState {
  searchTerm: string;
  results: [];
  resultsVisibility: boolean;
  target: IAddress;
  targetIsSet: boolean;
  multipleLocations: boolean;
  availability: {
    code: number | null;
    partnerId: string;
  };
  brlLocation: boolean;
  returnUrl: string;
  searchFormVisability: boolean;
  requestFormVisability: boolean;
}

export default class LeadsGenerator2 extends React.Component<{}, IState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      searchTerm: '',
      results: [],
      resultsVisibility: false,
      target: {
        id: '',
        street: '',
        num: '',
        zip: '',
        city: '',
      },
      targetIsSet: false,
      multipleLocations: false,
      availability: {
        code: null,
        partnerId: '',
      },
      brlLocation: false,
      returnUrl: '',
      searchFormVisability: true,
      requestFormVisability: false,
    };
  }

  public componentDidMount = (): void => {
    this.checkBrlLocation();
  };

  public componentDidUpdate = (previousProps: {}, previousState: IState) => {
    if (this.state.searchTerm !== previousState.searchTerm) {
      locationSearchApi(this.state.searchTerm).then((results) => {
        this.setState({ results });
        if (this.state.results.length) {
          this.setState({ resultsVisibility: true });
        }
      });
    }
  };

  private handleAvailabilityCheck = (address: string | undefined, postcode: string | undefined): void => {
    availabilityCheckApi(address, postcode).then((availabilityData) => {
      this.setState({
        availability: {
          code: availabilityData.availabilitycode,
          partnerId: availabilityData.partnerId,
        },
      });
    });
  };

  private handleSearch = (event: React.SyntheticEvent<HTMLInputElement>): void => {
    this.setState({ searchTerm: event.currentTarget.value });
  };

  private handleTargetLocation = (event: React.SyntheticEvent<HTMLElement>): void => {
    const data = event.currentTarget.dataset;
    this.setState({
      resultsVisibility: false,
      target: {
        id: data.id,
        street: data.street,
        num: data.num,
        zip: data.zip,
        city: data.city,
      },
      targetIsSet: true,
      searchTerm: `${data.street} ${data.num}, ${data.zip} ${data.city}`,
    });
    this.handleAvailabilityCheck(`${data.street} ${data.num}`, data.zip);
  };

  private handleChecked = (event: React.SyntheticEvent<Element>): void => {
    this.setState({ multipleLocations: !this.state.multipleLocations });
  };

  private handleCollapse = (event: React.SyntheticEvent<HTMLButtonElement>): void => {
    event.preventDefault();
    if (this.state.targetIsSet) {
      this.setState({ requestFormVisability: true, searchFormVisability: false });
    }
  };

  private handleTryAgain = (event: React.SyntheticEvent<HTMLButtonElement>): void => {
    event.preventDefault();
    this.setState({ searchTerm: '', searchFormVisability: true, requestFormVisability: false });
  };

  private checkBrlLocation = (url?: string): void => {
    const domainName: string = url || window.location.href;
    const urlContainsBrl: boolean = regexTest(/boligselskap/, domainName, true, true);
    if (urlContainsBrl) {
      this.setState({ brlLocation: true });
    }
  };

  private getReturnUrl = (url?: string): string => {
    const returnUrl: string = url || window.location.href;
    const returnUrlWithParameter = `${returnUrl}?success`;
    return returnUrlWithParameter;
  };

  public render = () => {
    return (
      <div id="leads-generator2" className={this.state.brlLocation ? 'brl-location' : ''}>
        <SuccessFeedback>
          <Collapse isOpened={this.state.searchFormVisability} className="location-search">
            <LocationSearch
              search={this.handleSearch}
              term={this.state.searchTerm}
              results={this.state.results}
              list={this.state.resultsVisibility}
              location={this.handleTargetLocation}
              multipleLocations={this.handleChecked}
              showForm={this.handleCollapse}
              brlLocation={this.state.brlLocation}
            />
          </Collapse>
          <Collapse isOpened={this.state.requestFormVisability} className="request-form">
            <RequestForm
              availability={this.state.availability}
              target={this.state.target}
              brlLocation={this.state.brlLocation}
              multipleLocations={this.state.multipleLocations}
              returnUrl={this.getReturnUrl}
              tryAgain={this.handleTryAgain}
            />
          </Collapse>
        </SuccessFeedback>
      </div>
    );
  };
}
